// PrivacyPal brand mark (interlocking "twin" forms). AirOps brand kit #30260.
import iconMark from 'assets/images/logo/privacypal-icon.png';

// ==============================|| LOGO ICON — PRIVACYPAL MARK ||============================== //

export default function LogoIcon() {
  return <img src={iconMark} alt="PrivacyPal" height={30} style={{ height: 30, width: 'auto', display: 'block' }} />;
}
